import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import useToneladasProvincia from "../../../hooks/administrador/recoleccion/useToneladasProvincia";
import "../../../styles/administrador.css";

const ToneladasProvincia = ({
  year,
  mes,
  token,
  idAdministrador,
  provinciaSeleccionada,
  ciudadSeleccionada,
}) => {
  const chartRef = useRef(null);
  const { data, loading, error } = useToneladasProvincia(
    year,
    mes,
    token,
    idAdministrador,
    provinciaSeleccionada,
    ciudadSeleccionada
  );

  useEffect(() => {
    if (loading || !chartRef.current) return;

    if (error || !Array.isArray(data) || data.length === 0) {
      if (chartRef.current) {
        chartRef.current.innerHTML =
          "<p style='text-align: center; color: black;'>No hay datos disponibles</p>";
      }
      return;
    }

    const chartDom = chartRef.current;
    let myChart = echarts.getInstanceByDom(chartDom);
    if (myChart) myChart.dispose();
    myChart = echarts.init(chartDom);

    const mostrandoCiudades =
      provinciaSeleccionada && provinciaSeleccionada !== "all";

    let titulo = "Gestión Realizada por provincia";
    if (mostrandoCiudades && data.length > 0) {
      titulo = `Gestión Realizada en ${
        data[0].provincia || "provincia seleccionada"
      }`;
    }

    const processedData = data.map((item) => {

      return {
        nombre: item?.descripcion ?? "Sin nombre",
        toneladas:
          parseFloat(
            ((item?.Peso_toneladas ?? "0") + "").replace(",", ".").trim()
          ) || 0,
        cantidad:
          parseInt(
            ((item?.Cantidad ?? "0") + "").replace(/,/g, "").trim(),
            10
          ) || 0,
      };
    });

    processedData.sort((a, b) => b.cantidad - a.cantidad);

    const datosGrafico = [...processedData];

    const pesoTotalValue = processedData.reduce(
      (sum, item) => sum + item.toneladas,
      0
    );
    const pesoTotal = pesoTotalValue.toFixed(2);
    const cantidadTotal = processedData
      .reduce((sum, item) => sum + item.cantidad, 0)
      .toLocaleString();

    const formatNumber = (value) => {
      const num = typeof value === "string" ? parseFloat(value) : value;
      return num.toLocaleString("es-ES", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    const colors = ["#d1dc5a", "#6ac5cb", "#45444e", "#a3b85b", "#3a6b74"];

    const option = {
      title: {
        text: titulo,
        left: "center",
        subtext: `CANTIDAD ENTREGADOS: ${cantidadTotal} [U] | \n TOTAL PESO: ${formatNumber(
          pesoTotal
        )} TONELADAS`,
        subtextStyle: {
          fontWeight: "bold",
          fontSize: "12px",
        },
        textStyle: {
          fontSize: 18,
          fontWeight: "bold",
        },
      },
      tooltip: {
        trigger: "axis",
        confine: true,
        axisPointer: {
          type: "shadow",
        },
        formatter: function (params) {
          const item = datosGrafico.find((d) => d.nombre === params[0].name);
          const pesoFormateado = item?.toneladas
            ? item.toneladas.toLocaleString("es-ES", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : "0,00";

          return (
            `${
              params[0].name
            }: <b>${params[0].value.toLocaleString()} Unidades</b>` +
            `<br/>Peso: <b>${pesoFormateado} Toneladas</b>`
          );
        },
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "10%",
        containLabel: true,
      },
      yAxis: {
        type: "category",
        data: datosGrafico.map((item) => item.nombre),
        axisLabel: {
          rotate: 0,
          fontSize: 12,
          interval: 0,
          fontWeight: "bold",
          formatter: function (value) {
            return value.length > 11 ? value.substring(0, 10) + "..." : value;
          },
        },
      },
      xAxis: {
        type: "value",
        name: "",
        axisLabel: {
          formatter: function (value) {
            if (value >= 1000) return (value / 1000).toFixed(1) + "K";
            return value;
          },
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: "dashed",
          },
        },
      },
      series: [
        {
          name: "Cantidad NFU",
          type: "bar",
          data: datosGrafico.map((item) => item.cantidad),
          barWidth: "50%",
          itemStyle: {
            color: function (params) {
              if (params.name === "Otros") {
                return "#AEAEAE";
              }
              return colors[params.dataIndex % colors.length];
            },
            borderRadius: [3, 3, 0, 0],
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
      ],
    };

    myChart.setOption(option);
  }, [data, loading, error, provinciaSeleccionada, ciudadSeleccionada]);

  if (loading) {
    return (
      <div className="grafica loading">
        Cargando datos de toneladas por provincia...
      </div>
    );
  }

  return (
    <div className="grafica" ref={chartRef} style={{ height: "700px" }}></div>
  );
};

export default ToneladasProvincia;
